/**
 * file_name.js
 *
 * 경 로 :
 * 목 적 :
 * 진 행 :
 * 주 의 :
 * 이 슈 :
 * 일 자 :
 * 작 성 :
 * 참 조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import B_Real from 'canvas/base/dev/child/base/B_Real';
import B_ChildTool from 'canvas/base/dev/child/base/B_ChildTool';
import B_Shape from 'canvas/base/dev/child/shape/B_Shape';
import B_Text from 'canvas/base/dev/child/text/B_Text';
import B_Dom from 'canvas/base/dev/child/dom/B_Dom';
import B_Define from 'canvas/base/dev/util/B_Define';
import B_Util from 'canvas/base/dev/util/B_Util';

let mix = (superclass) => new MixinBuilder(superclass);

const B_ToolPopup = (function(){

	// [V]
	const $ = {
		_strDomId : null,
		isActivePopup : null, // 진행/중지 여부 (애니메이션)
		isOpenPopup : null, // 열림/닫힘 여부
		_numHeight : null,
		_strPosition : null,
		_txtTitle : null,
		_txtContents : null,
		_objBG : null,
		_strBgColor : null,
		_objLine : null,
		_strLineColor : null,
		_numTime  : null,
		_cbPopup : null,
		_classText : null,
		_boolDisabled : null // 사용자의 disabled 처리방식 요청사항
	};

	class B_ToolPopup extends mix(B_Real).with(B_ChildTool, B_Shape) {

		constructor(obj) {
			super(obj);

			// [S]
			this._CWIDTH = this.CODMOS.CANVAS.width;
			this._CHEIGHT = this.CODMOS.CANVAS.height;

			// [S] 팝업 활성 상태
			this.isOpenPopup = false;
			this.isActivePopup = false;

			// [S]
			this._objBG = new createjs.Shape();
			this._objLine = new createjs.Shape();
			this._container.addChild(this._objBG, this._objLine);
			this._initDom();
		}

		// [F] public

		setWidth(w) {
			this[B_Define.POPUP_DOM_OBJECT_ID]._w = w;
			this.POPUP_WIDTH = w; // 팝업 가로
			this._pixelX = (this._CWIDTH - w) / 2; // 팝업 마진 (중앙정렬)
			return this;
		}

		setHeight(h) {
			this[B_Define.POPUP_DOM_OBJECT_ID]._h = h;
			this.POPUP_HEIGHT = h; // 팝업 세로
			return this;
		}

		setPadding(p) {
			this[B_Define.POPUP_DOM_OBJECT_ID]._p = p;
			return this;
		}

		/**
		 * @DES :: 아래서 위로 올라가는 팝업
		 * @IP1 :: strColor {str}
		 * @IP2 :: strContents {str}
		 * @IP3 :: numTime {num}
		 * @IP4 :: boolDisabled {bool}
		 * @IP5 :: cb {func}
		 * @O.P :: null
		 * @S.E :: 특이사항없음
		 */
		downToUp(strColor, strContents, numTime, boolDisabled, cb) {
			if(cb) this._cbPopup = cb;
			this._popup(strColor, strContents, numTime, boolDisabled, B_Define.POPUP_POSITION[0]);
		}

		/**
		 * @DES :: 위에서 아래로 내려가는 팝업
		 * @IP1 :: strColor {str}
		 * @IP2 :: strContents {str}
		 * @IP3 :: numTime {num}
		 * @IP4 :: boolDisabled {bool}
		 * @IP5 :: cb {func}
		 * @O.P :: null
		 * @S.E :: 특이사항없음
		 */
		upToDown(strColor, strContents, numTime, boolDisabled, cb) {
			if(cb) this._cbPopup = cb;
			this._popup(strColor, strContents, numTime, boolDisabled, B_Define.POPUP_POSITION[1]);
		}

		/**
		 * @DES :: 팝업닫기
		 * @IP1 :: cb {func}
		 * @O.P :: null
		 * @S.E :: 포지션에 따라 다른 처리, 캔버스 활성화 해제
		 */
		close() {
			// /*[T]*/ console.log('popup close call');

			// Dom 먼저 끄기
			if(
				this.isOpenPopup // 열림
				&&
				!this.isActivePopup // 활성 ㄴㄴ
			) {
				this.isOpenPopup = false; // [#] 팝업 Open 상태 :: 닫힘
				this.isActivePopup = true; // [#] 팝업 Active 상태 :: 진행

				this._toggleDom(false, ()=> {

					// Position에 따른 다른 처리
					switch(this._strPosition) {
						case B_Define.POPUP_POSITION[0]: // [#] BOTTOM
							var Y = this._CHEIGHT + B_Define.POPUP_RADIUS;
							break;
						case B_Define.POPUP_POSITION[1]: // [#] TOP
							var Y = - this.POPUP_HEIGHT - B_Define.POPUP_RADIUS;
							break;
						default:
							this._pixelY = - this.POPUP_HEIGHT;
							return;
					}
					this.CODMOS.ANIMATE._tween.tween(this, '', {
						arrStep : [
							{
								option : { y : Y },
								time   : B_Define.POPUP_MOVE_TIME,
								effect : 'bounceOut'
							}
						]
					}, () => {
						this.isActivePopup = false; // [#] 팝업 Active 상태 :: 중지

						// [#] Canvas Active :: 진행
						this.CODMOS.start();
						this._strPosition = ''; // text full
						if(this._cbPopup) this._cbPopup(); // popup callback
					});
				});
			}

		}

		// [F] protected

		/**
		 * @DES :: DOM 초기화
		 * @IP1 :: null
		 * @O.P :: null
		 * @S.E ::
		 */
		_initDom() {
			const CLASS_DOM = class extends mix(B_Real).with(B_Dom) { constructor(obj) { super(obj); } };

			this[B_Define.POPUP_DOM_OBJECT_ID] = new CLASS_DOM({
				cm : this.CODMOS,
				id : B_Define.POPUP_DOM_OBJECT_ID,
				dom : B_Define.POPUP_DOM_ID,
				type : B_Define.TOOL_TYPE
			});

			// [#] popup dom 객체 기본 속성 설정
			this.setWidth(B_Define.POPUP_DEFAULT_WIDTH);
			this.setHeight(B_Define.POPUP_DEFAULT_HEIGHT);
			this.setPadding(B_Define.POPUP_DEFAULT_PADDING);

			// => _container pixelX를 따라가기 때문에 따로 pixel를 처리하지 않아도 됩니다.
			this[B_Define.POPUP_DOM_OBJECT_ID]._visible = false; // 기본 안보임 처리
			this[B_Define.POPUP_DOM_OBJECT_ID]._alpha = 0; // 기본 안보임 처리
			// this[B_Define.POPUP_DOM_OBJECT_ID]._setPoint(50, 50);
			// this[B_Define.POPUP_DOM_OBJECT_ID]._pixelX = this._CWIDTH / 2;
			// this[B_Define.POPUP_DOM_OBJECT_ID]._pixelY = this._CWIDTH / 2;
			this._container.addChild(this[B_Define.POPUP_DOM_OBJECT_ID]._container);
		}

		/**
		 * @DES :: BG 초기화 & 생성하기
		 * @IP1 :: position {str}
		 * @S.E ::
		 */
		_makeBG(position) {
			if(position == B_Define.POPUP_POSITION[0]/*BOTTOM*/) {
				this._objBG
					.graphics
					.clear()
					.beginFill(B_Define.POPUP_COLOR_BG)
					.drawRect(
						// x & y & w & h
						0, 0, this.POPUP_WIDTH, this.POPUP_HEIGHT
					);
			}
			if(position == B_Define.POPUP_POSITION[1]/*TOP*/) {
				this._objBG
					.graphics
					.clear()
					.beginFill(B_Define.POPUP_COLOR_BG)
					.drawRect(
						// x & y & w & h
						0, 0, this.POPUP_WIDTH, this.POPUP_HEIGHT,
					);
			}
		}

		/**
		 * @DES :: Line 초기화 & 생성하기
		 * @IP1 :: position {str}
		 * @IP2 :: color {str}
		 * @O.P :: null
		 * @S.E ::
		 */
		_makeLine(position, color) {
			if(position == B_Define.POPUP_POSITION[0]/*BOTTOM*/) {
				this._objLine
					.graphics
					.clear()
					.beginFill(B_Define.POPUP_COLOR[color])
					.drawRoundRectComplex(
						// x & y & w & h
						0, - B_Define.POPUP_RADIUS, this.POPUP_WIDTH, B_Define.POPUP_RADIUS,
						// r1 & r2 & r3 & r4
						B_Define.POPUP_RADIUS, B_Define.POPUP_RADIUS, 0, 0 );
			}
			if(position == B_Define.POPUP_POSITION[1]/*TOP*/) {
				this._objLine
					.graphics
					.clear()
					.beginFill(B_Define.POPUP_COLOR[color])
					.drawRoundRectComplex(
						// x & y & w & h
						0, this.POPUP_HEIGHT, this.POPUP_WIDTH, B_Define.POPUP_RADIUS,
						// r1 & r2 & r3 & r4
						0, 0, B_Define.POPUP_RADIUS, B_Define.POPUP_RADIUS );
			}
		}

		/**
		 * @DES :: 팝업열기
		 * @IP1 :: null
		 * @O.P :: null
		 * @S.E ::
		 */
		_open() {
			// [#] Canvas Active :: 중지
			const ALPHA = this._boolDisabled ? B_Define.DISABLED_ALPHA_DARK : B_Define.DISABLED_ALPHA_SOFT;
			this.CODMOS.stop(ALPHA);

			if(this._strPosition == B_Define.POPUP_POSITION[0]) {
				this._pixelY = this._CHEIGHT;
				var Y = this._CHEIGHT - this.POPUP_HEIGHT;
			}
			if(this._strPosition == B_Define.POPUP_POSITION[1]) {
				this._pixelY = - this.POPUP_HEIGHT;
				var Y = 0;
			}
			this.CODMOS.ANIMATE._tween.tween(this, '', {
				arrStep : [
					{
						option : { y : Y },
						time   : B_Define.POPUP_MOVE_TIME,
						effect : 'bounceOut'
					}
				]
			}, () => {
				this._toggleDom(true, () => {
					this.isActivePopup = false; // [#] 팝업 Active 상태 :: 중지
				});
			});
		}

		/**
		 * @DES :: 팝업설정
		 * @IP1 :: strColor {str}
		 * @IP2 :: strTitle {str}
		 * @IP3 :: strContents {str}
		 * @IP4 :: numTime {num}
		 * @IP5 :: position {str}
		 * @O.P ::
		 * @S.E ::
		 */
		_popup(strColor, strContents, numTime, boolDisabled, position) {
			// /*[T]*/ console.log('_popup call');

			if(
				!this.isOpenPopup // 열림 ㄴㄴ
				&&
				!this.isActivePopup // 활성 ㄴㄴ
			) {
				this.isOpenPopup = true; // [#] 팝업 Open 상태
				this.isActivePopup = true; // [#] 팝업 Active 상태
				this._boolDisabled = boolDisabled; // [#] disabled
				this._strPosition = position; // [#] position
				this._makeBG( position ); // [#] 배경 Shape
				this._makeLine( position, strColor ); // [#] 라인 Shape

				this[B_Define.POPUP_DOM_OBJECT_ID].appendHtml(strContents); // [#] 텍스트
				// this[B_Define.POPUP_DOM_OBJECT_ID]._setPoint(0, 50); // [#] 텍스트 중심

				this._open();
				if(numTime) setTimeout(() => { this.close(); }, numTime * 1000);
			}
		}

		/**
		 * @DES ::
		 * @IP1 ::
		 * @O.P ::
		 * @S.E ::
		 */
		_toggleDom(boolStatus, cb) {
			let alpha;
			if(boolStatus) alpha = 1; // 열림
			else           alpha = 0; // 닫힘

			this[B_Define.POPUP_DOM_OBJECT_ID]._visible = true;
			this.CODMOS.ANIMATE._tween.tween(this[B_Define.POPUP_DOM_OBJECT_ID], '', {
				arrStep : [
					{
						option : { alpha : alpha },
						time   : B_Define.POPUP_MOVE_TIME,
						effect : 'none'
					}
				]
			}, () => {
				this[B_Define.POPUP_DOM_OBJECT_ID]._visible = boolStatus; // [#] visible => visibility 연결되어있음
				if(cb) cb();
			});
		}

	}

	return B_ToolPopup;
}());

export default B_ToolPopup;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/tool/B_ToolPopup.js